import React, { useEffect } from 'react';
import { Images, PermissionList, RolePermission, useModal, User, useSecondaryModal } from 'utils';
import { EditWithIcon } from '../../buttons';
import { ApptDetailRow, LinkRow, LocalDateRow } from '../../table';
import { FormBuilderProvider } from '../../../pages/forms/formDetail';
import { ReportBuilder } from '../../../pages/forms/progressReport/reportBuilder';
import { noteActions } from '../../../store';
import { useDispatch } from 'react-redux';
import { NoteHistoryModal } from './noteHistoryModal';

export const NoteInfo = ({ note, handleAction, permissions, apptId, modalWidth, notCheckUser, notEditAble }) => {
    const checkPermissions = permissions?.length ? RolePermission([...permissions]) : true;
    const { userInfo } = User();
    const dispatch = useDispatch();
    const { openSecondary } = useSecondaryModal();


    useEffect(() => {
        if (note?.id) dispatch(noteActions.viewNote({ ids: [note.id] }));
    }, []);

    return (
        <>
            <div style={{ width: modalWidth ? modalWidth : 816 }}>
                <div className="space-between-flex-start" style={{ marginTop: 6 }}>
                    <p className="note-subject" style={{ marginTop: 6 }}>
                        {note?.template?.title}
                    </p>
                    {checkPermissions && handleAction && (
                        <div className="flex-align-center" style={{ gap: 16 }}>
                            <EditWithIcon
                                disabled={notCheckUser ? false : (note?.creatorId || note?.createdById) !== userInfo?.id}
                                styles={{ opacity: notCheckUser ? 1 : (note?.creatorId || note?.createdById) !== userInfo?.id ? 0.5 : 1 }}
                                handleClick={() => openSecondary(<NoteHistoryModal noteId={note?.id} />)}
                                icon={Images.showEye}
                            />
                            {!notEditAble && (
                                <EditWithIcon
                                    disabled={notCheckUser ? false : (note?.creatorId || note?.createdById) !== userInfo?.id}
                                    styles={{
                                        opacity: notCheckUser ? 1 : (note?.creatorId || note?.createdById) !== userInfo?.id ? 0.5 : 1,
                                    }}
                                    handleClick={() => handleAction(note, 'edit')}
                                />
                            )}
                            <EditWithIcon
                                disabled={notCheckUser ? false : (note?.creatorId || note?.createdById) !== userInfo?.id}
                                styles={{ opacity: notCheckUser ? 1 : (note?.creatorId || note?.createdById) !== userInfo?.id ? 0.5 : 1 }}
                                handleClick={() => handleAction(note, 'deleteNote')}
                                icon={Images.redTrash}
                            />
                        </div>
                    )}
                </div>

                <div className="note-detail-general-info-box">
                    {apptId && (
                        <div className="flex-align-center" style={{ gap: 8 }}>
                            <p className="note-detail-info-title">Appt ID:</p>
                            <div>
                                <ApptDetailRow name={note?.apptDisplayId || note?.displayId} id={note?.id} showWidth={'auto'} />
                            </div>
                        </div>
                    )}
                    <div className="flex-align-center" style={{ gap: 8 }}>
                        <p className="note-detail-info-title">Created:</p>
                        <div className="flex-align-center">
                            {(note?.created || note?.createdAt) && (
                                <span className="note-detail-value">
                                    {/*{`${moment(note?.created).format('MM/DD/YY, hh:mma')} by `}*/}
                                    <LocalDateRow date={note?.created || note?.createdAt} /> by
                                </span>
                            )}
                            <LinkRow
                                name={note?.creatorFullName || note?.createdByFullName}
                                href={
                                    RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${note?.creatorId || note?.createdById}` : ''
                                }
                                checkPermission={
                                    note?.creatorId || note?.createdById ? RolePermission([PermissionList.STAFF_READ.code]) : null
                                }
                                textWidth={8}
                            />
                        </div>
                    </div>
                    {note?.updated && note?.updaterFullName && (
                        <div className="flex-align-center" style={{ gap: 8 }}>
                            <p className="note-detail-info-title">Last Updated:</p>
                            <div className="flex-align-center">
                                <span className="note-detail-value">
                                    <LocalDateRow date={note?.updated} /> by
                                    {/*{`${moment(note?.updated).format('MM/DD/YY, hh:mma')} by `}*/}
                                </span>
                                <LinkRow
                                    name={note?.updaterFullName}
                                    href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${note?.updaterId}` : ''}
                                    checkPermission={note?.updaterId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                                    textWidth={8}
                                />
                            </div>
                        </div>
                    )}
                </div>

                {note?.template && (
                    <div className="note-detail-body-info-box">
                        <FormBuilderProvider initialFormList={note.template} initialImageUrls={note.template?.imageUrls}>
                            <ReportBuilder isDetail />
                        </FormBuilderProvider>
                    </div>
                )}
            </div>
        </>
    );
};
